import { OrgMode } from '@/lib/models/org';
import { createContext } from 'react';

export type FeatureFlags = {
  canChangeConnector: boolean;
  canViewConnectorArn: boolean;
  canChangePrivateModels: boolean;
  canChangeAuth: boolean;
  canChangeSync: boolean;
  canChangePolicy: boolean;
  canManageAdmins: boolean;
  canChangeGroups: boolean;
  canChangeUsers: boolean;
  canViewConversations: boolean;
  canChangeCustomMessage: boolean;
  canChangeBranding: boolean;
  canChangeContextProviders: boolean;
  canChangeAgents: boolean;
  canChangeClassifiers: boolean;
  canChangeTelemetry: boolean;
  hasDemoUserEventFilter: boolean;
  canViewConfidentialDatasources: boolean;
  canViewCharts: boolean;
  canViewDemoConnectors: boolean;
  canViewReroute: boolean;
  hasPolicyV1: boolean;
  hasPolicyV2: boolean;
  hasAssume: boolean;
  hasIntents: boolean;
  hasClassifiers: boolean;
  canConfigureConversationExport: boolean;
  hasPortalChat: boolean;
};

export type FeatureSettings = FeatureFlags & {
  orgMode: OrgMode;
  getTooltip: (feature: FeatureId) => string;
  hasFeature: (feature: string) => boolean;
  loading: boolean;
};

export type FeatureFlag = keyof FeatureFlags;

export type FeatureId =
  | 'change-connector'
  | 'add-connector'
  | 'change-private-model'
  | 'add-private-model'
  | 'change-sync'
  | 'change-auth'
  | 'change-policy'
  | 'add-group'
  | 'add-user'
  | 'view-conversation'
  | 'add-policy'
  | 'change-custom-message'
  | 'change-branding'
  | 'add-context-provider'
  | 'change-context-provider'
  | 'add-agent'
  | 'change-agent'
  | 'add-classifier'
  | 'change-classifier'
  | 'add-telemetry'
  | 'change-telemetry'
  | 'view-demo-connectors'
  | 'has-policy-v1'
  | 'has-policy-v2'
  | 'has-intents'
  | 'has-classifiers';

export const FeatureContext = createContext<FeatureSettings>({
  orgMode: 'platform',
  getTooltip: () => '',
  hasFeature: () => false,
  loading: false,
  canChangeConnector: false,
  canViewConnectorArn: false,
  canChangePrivateModels: false,
  canChangeAuth: false,
  canChangeSync: false,
  canChangePolicy: false,
  canManageAdmins: false,
  canChangeGroups: false,
  canChangeUsers: false,
  canViewConversations: false,
  canChangeCustomMessage: false,
  canChangeBranding: false,
  canChangeContextProviders: false,
  canChangeAgents: false,
  canChangeClassifiers: false,
  canChangeTelemetry: false,
  hasDemoUserEventFilter: false,
  canViewConfidentialDatasources: false,
  canViewCharts: false,
  canViewDemoConnectors: false,
  canViewReroute: false,
  hasPolicyV1: false,
  hasPolicyV2: false,
  hasAssume: false,
  hasIntents: false,
  hasClassifiers: false,
  canConfigureConversationExport: false,
  hasPortalChat: false,
});
